import {NavLink} from 'src/ui-components/NavigationMenu/NavLink';
import {useState} from 'react';
import {NavItemLinkProps} from '../../components/sidebar/SidebarList';
import {ChevronDown, ChevronUpWhite} from '../Iconpack';
import {ChevronsUp} from 'lucide-react';

export const NestedNavLink: React.FC<{
    item: NavItemLinkProps;
    currentPath: string;
    onCloseClick: () => void;
    menuAvailableForDevice(item: NavItemLinkProps): boolean;
    featureAvailable(menu: NavItemLinkProps): boolean;
}> = ({item, currentPath, onCloseClick, menuAvailableForDevice, featureAvailable}) => {
    const [expanded, setExpanded] = useState(false);

    const toggleExpanded = () => {
        setExpanded(!expanded);
    };

    return (
        <>
            <div className='cursor-pointer' onClick={toggleExpanded}>
                <NavLink as='div' asProps={{}} active={currentPath === item.path}>
                    {item.icon && <item.icon />}
                    <div className='flex items-center justify-center gap-3'>
                        <span className='text-[1rem] font-[500] text-[#F2F4F7] md:text-[0.875rem]'>{item.title}</span>
                        {!expanded ? (
                            <ChevronDown height={20} width={20} color={'#FFFFFF'} />
                        ) : (
                            <ChevronUpWhite height={20} width={20} />
                        )}
                    </div>
                </NavLink>
            </div>
            {expanded && (
                <ul>
                    {item.nestedItems?.map((nestedItem) =>
                        menuAvailableForDevice(nestedItem) && featureAvailable(nestedItem) ? (
                            <li key={nestedItem.title} className='pl-9'>
                                <NavLink
                                    as='a'
                                    asProps={{href: nestedItem.path, target: nestedItem.target}}
                                    active={currentPath === nestedItem.path}
                                    className='text-[1rem]'
                                    onCloseClick={onCloseClick}>
                                    {nestedItem.title}
                                </NavLink>
                            </li>
                        ) : null,
                    )}
                </ul>
            )}
        </>
    );
};
